import { createSlice } from '@reduxjs/toolkit';
import { fetchCartThunk, addToCart as addToCartThunk, removeFromCartThunk, updateCart, clearCartThunk } from '../actions/cartActions';


export const DELIVERY_THRESHOLD = 1000;

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    removedItems: [],
    subtotal: 0,
    delivery: 0,
    discount: 0,
    total: 0,
    kitTotal: 0,
    itemTotal: 0,
    invoiceTotal: 0,
    groupItemTotal: 0,
  },
  reducers: {
    addToCart: (state, action) => {
      // Only update state
      // API logic handled in thunk/extraReducers
    },
    removeFromCart: (state, action) => {
      // Only update state
    },
    updateQuantity: (state, action) => {
      // Only update state
    },
    clearCart: (state, action) => {
      state.items = [];
      state.removedItems = [];
    },
    dismissRemovedItems: (state) => {
      state.removedItems = [];
    },
    calculateSubtotal: (state) => {
      const kitTotal = state.items.reduce((acc, item) => {
        const kitPrice = item.kitDetails?.priceLevel1 || 0;
        const kitQty = item.kitQuantity || 0;
        return acc + (kitPrice * kitQty);
      }, 0);

      const itemTotal = state.items.reduce((acc, item) => {
        // const itemPrice = item.itemDetails?.price || 0;
        // const itemQty = item.itemQuantity || 0;
        if (!item.itemDetails) return acc;
         //cal for osk
         if (item.itemDetails.groupTypeId === 3) {
         const itemPrice = item.itemDetails.priceLevel1 || 0;
         const itemQty = item.kitQuantity || 0;
          return acc + (itemPrice * itemQty);
         }
        //cal for items
         const itemPrice = item.itemDetails.price || 0;
         const itemQty = item.itemQuantity || 0;

        return acc + (itemPrice * itemQty);
      }, 0);

      const invoiceTotal = state.items.reduce((acc, item) => {
        const invoicePrice = item.invoiceDetails?.amountDue || 0;
        return acc + invoicePrice;
      }, 0);

      const groupItemTotal = state.items.reduce((acc, item) => {
        const groupItemPrice = item.groupDetails?.price || 0;
        const groupItemQty = item.groupQuantity || 0;
        return acc + (groupItemPrice * groupItemQty);
      }, 0);

      const subtotal = kitTotal + itemTotal + invoiceTotal + groupItemTotal;

      state.kitTotal = kitTotal;
      state.itemTotal = itemTotal;
      state.invoiceTotal = invoiceTotal;
      state.groupItemTotal = groupItemTotal;
      state.subtotal = subtotal;
      state.delivery = (subtotal - invoiceTotal) >= DELIVERY_THRESHOLD ? 0 : ((subtotal - invoiceTotal) * 0.15);
    },   
    updateDelivery: (state, action) => {
      state.delivery = action.payload.deliveryCost;
    },
    applyDiscount: (state, action) => {
      state.discount = action.payload.discount;
    },
    getTotal: (state) => {
      const discountAmount = state.subtotal * (state.discount || 0);
      state.total = state.subtotal - discountAmount + state.delivery;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCartThunk.fulfilled, (state, action) => {
        applyCartResponse(state, action.payload);
      })
      .addCase(addToCartThunk.fulfilled, (state, action) => {
        applyCartResponse(state, action.payload);
      })
      .addCase(removeFromCartThunk.fulfilled, (state, action) => {
        applyCartResponse(state, action.payload);
      })
      .addCase(updateCart.fulfilled, (state, action) => {
        applyCartResponse(state, action.payload);
      })
      .addCase(clearCartThunk.fulfilled, (state, action) => {
        applyCartResponse(state, action.payload);
      });
  }
});

// API now returns { items, removedItems } instead of a bare array; keep old array shape as a fallback.
// removedItems accumulates across fetches (a later fetch that removed nothing must not
// wipe out a removal a prior fetch already reported) - only dismissRemovedItems clears it.
function applyCartResponse(state, payload) {
  if (Array.isArray(payload)) {
    state.items = payload;
    return;
  }
  state.items = Array.isArray(payload?.items) ? payload.items : [];

  const newlyRemoved = Array.isArray(payload?.removedItems) ? payload.removedItems : [];
  if (newlyRemoved.length === 0) return;

  const key = (r) => `${r.itemId ?? ''}-${r.kitId ?? ''}-${r.itemNumber ?? ''}`;
  const seen = new Set(state.removedItems.map(key));
  for (const r of newlyRemoved) {
    const k = key(r);
    if (!seen.has(k)) {
      seen.add(k);
      state.removedItems.push(r);
    }
  }
}

export const { addToCart, removeFromCart, updateQuantity, clearCart, dismissRemovedItems, calculateSubtotal, updateDelivery, applyDiscount, getTotal } = cartSlice.actions;

export default cartSlice.reducer;
